<template>
  <b-card-actions action-collapse title="Liste des admins">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllclients()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel>
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/quote/quote?customer=${props.row._id}`" >Consulter devis</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/command?customer=${props.row._id}`" >Consulter commande</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/invoice/invoice?customer=${props.row._id}`" >Consulter facture</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="UpdateClient(props.row._id)"
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteClient(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-if="props.column.field === 'telNumbers'">
          <ul v-for="(number, index) in props.row.telNumbers" :key="index">
            <li v-if="number!=''">{{ number }}</li>
          </ul>
        </span>
        <!-- <span v-if="props.column.field === 'visitingDays'">
        <ul v-for="(day, index) in props.row.visitingDays" :key="index">
            <li>{{ day }}</li>
          </ul> 
          <div>{{ props.row.visitingDays }}</div>
        </span>-->

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      json_data: [],
      json_fields: {
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        adresse: "address",
        "Code postal": "postalCode",
        numero: "telNumbers",
        "Raison sociale": "socialReason",
        "Secteur d'activité": "activityArea",
        "Nom du responsable, Poste": "responsible",
        "Type du client": "type",
        "Type du vente": "saleType",
        Remise: "discount",
        "Matricule Fiscale": "registrationNumber",
        "Jours de visite": "visitingDays",
      },
      pageLength: 5,
      dir: false,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Nom",
          field: "firstName",
          filterOptions: {
            enabled: true,
            placeholder: "Nom",
          },
        },
        {
          label: "Prénom",
          field: "lastName",
          filterOptions: {
            enabled: true,
            placeholder: "Prénom",
          },
        },
        {
          label: "Email",
          field: "email",
          filterOptions: {
            enabled: true,
            placeholder: "Email",
          },
        },
        {
          label: "City",
          field: "city",
          filterOptions: {
            enabled: true,
            placeholder: "Ville",
          },
        },
        {
          label: "Adresse",
          field: "address",
          filterOptions: {
            enabled: true,
            placeholder: "Adresse",
          },
        },

        {
          label: "Code postal",
          field: "postalCode",
          filterOptions: {
            enabled: true,
            placeholder: "Code postal",
          },
        },
        {
          label: "Numéro de téléphone",
          field: "telNumbers",
          filterOptions: {
            enabled: true,
            placeholder: "Numéro de téléphone",
          },
        },

        {
          label: "Raison sociale",
          field: "socialReason",
          filterOptions: {
            enabled: true,
            placeholder: "Raison sociale",
          },
        },
        {
          label: "Secteur d'activité",
          field: "activityArea",
          filterOptions: {
            enabled: true,
            placeholder: "Secteur d'activité",
          },
        },
        {
          label: "Nom du responsable, Poste",
          field: "responsible",
          filterOptions: {
            enabled: true,
            placeholder: "Nom du responsable, Poste",
          },
        },
        {
          label: "Type du client",
          field: "type",
          filterOptions: {
            enabled: true,
            placeholder: "Type du client",
          },
        },
        {
          label: "Type du vente",
          field: "saleType",
          filterOptions: {
            enabled: true,
            placeholder: "Type du vente",
          },
        },
        {
          label: "Remise",
          field: "discount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Matricule Fiscale",
          field: "registrationNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Matricule Fiscale",
          },
        },
        {
          label: "Jours de visite",
          field: "visitingDays",
          filterOptions: {
            enabled: true,
            placeholder: "Jours de visite",
          },
          formatFn: this.visitingDaysFormat,
        },

        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.nameFormat,
        },
        {
          label: "Date de modification",
          field: "updatedAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date de modification",
          },
          formatFn: this.dateFormat,
        },

        // {
        //   label: "Image",
        //   field: "image",
        //   sortable: false,
        //   // html: true,
        // },
       
      ],
      rows: [],
      searchTerm: "",
    };
  },
  async created() {
    await this.getAllDataClient();
  },
  methods: {
    async getAllDataClient() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/customers"
      );
      this.rows = response.data;
      this.json_data = response.data;
      console.log(this.rows);
    },
         deleteAllClients() {
      var deleteIds = [];
      this.$refs["table-client"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      console.log(deleteIds, this.$refs["table-client"].selectedRows);
      axios
        .delete(
          `https://mtl-feeder-nodejs.onrender.com/api/customers?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataClient();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Client bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    DeleteClient(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer ce client ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(
              `https://mtl-feeder-nodejs.onrender.com/api/customers?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataClient();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `client bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    UpdateClient(id) {
      var routerLink = "/client/edit-client?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // imgFormat: function (value) {
    //   if (value) {
    //     return (
    //       "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
    //       value
    //     );
    //   }
    // },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    visitingDaysFormat: function (value) {
      if (value) {
        return value.join(", ");
      }
    },
    // name agent de saisie
    nameFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}

.btn-delete-all {
  margin-left: 3%;
}
</style>
